"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicableDiscountsForRatePolicies = void 0;
const getLowestLongStayDiscount_1 = require("./getLowestLongStayDiscount");
const getValidEarlyBirdDiscounts_1 = require("./getValidEarlyBirdDiscounts");
const getApplicableDiscountsForRatePolicies = (data, number_of_nights, days_in_advance) => {
    const is_stackable = data.every((item) => item.discount?.stackable);
    const is_apply_discount_to_board_surplus = data.every((item) => item.discount?.apply_discount_to_board_surplus);
    const is_apply_discount_to_extra_bed = data.every((item) => item.discount?.apply_discount_to_extra_bed);
    const has_long_stay = data.every((item) => item.discount?.long_stay_discounts);
    const has_early_bird = data.every((item) => item.discount?.early_bird_discounts &&
        item.discount.early_bird_discounts.some((discount) => discount.min_days_in_advance <= days_in_advance));
    const early_bird_discount = has_early_bird
        ? (0, getValidEarlyBirdDiscounts_1.getValidEarlyBirdDiscounts)(data, days_in_advance)
        : null;
    // remove duplicate early bird discounts
    if (early_bird_discount) {
        const unique_discounts = early_bird_discount.filter((value, index, self) => self.findIndex((t) => t.discount_percentage === value.discount_percentage &&
            t.min_days_in_advance === value.min_days_in_advance) === index);
        if (unique_discounts.length > 0) {
            early_bird_discount.length = 0;
            unique_discounts.forEach((item) => {
                early_bird_discount.push(item);
            });
        }
    }
    const long_stay_discount = has_long_stay
        ? (0, getLowestLongStayDiscount_1.getLowestLongStayDiscount)(data, number_of_nights)
        : null;
    return {
        early_bird: early_bird_discount,
        long_stay: long_stay_discount,
        stackable: is_stackable,
        apply_discount_to_board_surplus: is_apply_discount_to_board_surplus,
        apply_discount_to_extra_bed: is_apply_discount_to_extra_bed,
        best: null,
    };
};
exports.getApplicableDiscountsForRatePolicies = getApplicableDiscountsForRatePolicies;
